// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".snack-thumbnail[data-v-5f9b5fb8]{position:relative;width:100%}.snack-thumbnail[data-v-5f9b5fb8]:before{display:block;padding-top:75.5102%;content:\"\"}@media (min-width: 768px){.snack-thumbnail[data-v-5f9b5fb8]:before{padding-top:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
